import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ObjectUrlService {
  urlBlobMap: Map<string, Blob> = new Map<string, Blob>();

  createObjectURL(blob: Blob): string {
    const url = window.URL.createObjectURL(blob);
    this.urlBlobMap.set(url, blob);
    return url;
  }

  revokeObjectURL(url: string) {
    try {
      if (this.urlBlobMap.has(url) && new URL(url).protocol === 'blob:') {
        window.URL.revokeObjectURL(url);
        this.urlBlobMap.delete(url);
      }
    } catch (e) {}
  }

  getFromObjectURL(url: string): Blob {
    return this.urlBlobMap.get(url);
  }
}
